var NavigationToEnum;
(function (NavigationToEnum) {
    NavigationToEnum["ikeaMainPage"] = "ikea web main page";
    NavigationToEnum["ikeaFavorites"] = "ikea web favorites";
    NavigationToEnum["ikeaCart"] = "ikea web shopping cart";
    NavigationToEnum["ikeaAssembly"] = "ikea assembly services info";
})(NavigationToEnum || (NavigationToEnum = {}));
export default NavigationToEnum;
//# sourceMappingURL=NavigationToEnum.js.map